import './social_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.InstagramContentView extends Monitoring.Views.SocialContents.SocialContentView
  tagName: "section"
  className: "content instagram"

  events: =>
    return _.extend({}, Monitoring.Views.SocialContents.SocialContentView.prototype.events, {
      "click .toggle" : "togglePhoto"
    })

  togglePhoto: (event) =>
    @$el.toggleClass('collapsed expanded', 0)
